import { observer } from 'mobx-react-lite';
import TopicList from './topic-list';
import { useParams } from 'react-router-dom';
import TopicEdit from './topic-edit';

export default observer(function Topic() {
    const { code } = useParams();

    return (
        <>
            {code ? <TopicEdit /> : <TopicList />}
        </>
    );
});
